// React libs
import React, { FC, useCallback } from 'react';
import get from 'lodash/get'
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup as RadioGroupComponent,
} from '@material-ui/core';
// Components
import ClearButton from '../ClearButton/ClearButton';
import FieldError from '../../Error/FieldError/FieldError';
// Type
import * as Types from './RadioGroup.type';
// Utils
import { hasErrors } from '../../../../Utils/FormUtils'

const RadioGroup: FC<Types.IProps> = ({
  field,
  form,
  label,
  options,
  clearable,
  ...props
}) => {
  const { errors, touched } = form;

  const customClasses = {
    root: '',
    colorPrimary: 'text-orange-300', // example
    colorSecondary: 'text-selection',
  };

  const customField = {
    ...field,
    onClick: (e: any) => {
      const val = (e.target.value || '').replace(/\s+/gi, ' ');
      form.setFieldValue(field.name, val.trim());
    },
  };
  const onClear = useCallback(() => {
    form.setFieldTouched(field.name, true)
    form.setFieldValue(field.name, '')
  }, [field.name, form])

  return (
    <div className='w-full' data-testid='radiogroup'>
      <FormControl component='fieldset'>
        <FormLabel component='legend' className='text-selection'>
          {label}
        </FormLabel>
        <RadioGroupComponent {...customField} {...props}>
          {options &&
            options.map((o: Types.IOption) => (
              <FormControlLabel
                key={o.value}
                value={o.value}
                control={<Radio classes={customClasses} />}
                label={o.label}
              />
            ))}
          {clearable && <ClearButton onClear={onClear} />}
        </RadioGroupComponent>
      </FormControl>
      {hasErrors(form, field.name) && (
        <FieldError
          color={
            props.color && ['primary', 'secondary'].includes(props.color)
              ? (props.color as 'primary' | 'secondary')
              : 'secondary'
          }
          errors={get(errors, field.name)}
          touched={touched}
        />
      )}
    </div>
  );
};

export default RadioGroup;
